import { render } from "./doctor-dashboard.vue?vue&type=template&id=0001f760&scoped=true"
import script from "./doctor-dashboard.vue?vue&type=script&lang=js"
export * from "./doctor-dashboard.vue?vue&type=script&lang=js"

import "./doctor-dashboard.vue?vue&type=style&index=0&id=0001f760&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0001f760"]])

export default __exports__